import { render, staticRenderFns } from "./SetTag.vue?vue&type=template&id=710cadfe&scoped=true&"
import script from "./SetTag.vue?vue&type=script&lang=js&"
export * from "./SetTag.vue?vue&type=script&lang=js&"
import style0 from "./SetTag.vue?vue&type=style&index=0&id=710cadfe&prod&lang=css&"
import style1 from "./SetTag.vue?vue&type=style&index=1&id=710cadfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710cadfe",
  null
  
)

export default component.exports